export default __webpack_public_path__ + "static/media/newlogo2.4f5296f2.jpg";